<header>
  <h1 mat-dialog-title class="truncate">
    <mat-icon fontIcon="add_ic_call"></mat-icon>
    Uploading {{ meta.file.name }}
  </h1>
  <aside>
    <mat-icon
      title="Close" (click)="closeDialog()" fontIcon="close">
    </mat-icon>
  </aside>
</header>
<mat-dialog-content>
  <form>
    <table class="table-striped full-width table-no-border-bottom">
      <tr>
        <td>
          <label for="callName">Call name</label>
        </td>
        <td>
          <input type="text" id="callName" class="full-width form-control truncate" placeholder="e.g 1st Interview"
                 [(ngModel)]="fileName" name="callName">
        </td>
      </tr>
      <tr>
        <td>
          <label for="appointmentDate">Date of appointment (UTC)</label>
        </td>
        <td>
          <input type="datetime-local" id="appointmentDate" class="form-control"
                 [(ngModel)]="appointmentDate" name="appointmentDate">
        </td>
      </tr>
    </table>

    <section mat-dialog-actions class="footer-btns">
      <button class="danger-btn-hover" (click)="closeDialog($event)" tabindex="0">cancel</button>
      <button type="submit" (click)="transcribe()"><mat-icon fontIcon="auto_awesome"></mat-icon> TRANSCRIBE</button>
    </section>
  </form>
</mat-dialog-content>
